import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { DocumentoDTO } from 'app/main/apps/shared/interfaces/documento.interface';
import { PersonaDTO } from 'app/main/apps/shared/interfaces/persona.interface';
import { PersonasService } from 'app/main/apps/shared/services/rest/personas.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

const ETIQUETAS = {
  identificacion: "Identificación",
  certificaciones: "Documentos",
};

@Component({
  selector: 'app-dialog-documentos-personal-apoyo',
  templateUrl: './dialog-documentos-personal-apoyo.component.html',
  styleUrls: ['./dialog-documentos-personal-apoyo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class DialogDocumentosPersonalApoyoComponent implements OnInit {
  
  etiquetas = null;
  rutPersona: number;
  documentos: DocumentoDTO[];
  persona: PersonaDTO;
  totalmenteCargado:boolean=false;

  constructor(private _personaSrvc:PersonasService,
              @Inject(MAT_DIALOG_DATA) public data: number,
              public dialogRef: MatDialogRef<DialogDocumentosPersonalApoyoComponent>,) {
                
               }

  ngOnInit(): void {
    
    this.etiquetas = ETIQUETAS;
    this.rutPersona = this.data;

    this._personaSrvc.fetchPersona(this.rutPersona)
      .subscribe(resp=>{
        this.persona=resp;
      }
    );

  }

}
